import TrackTag from './TrackTag';

export default TrackTag;
